export default "<sidebar-component></sidebar-component>\r\n\r\n<router-outlet></router-outlet>\r\n";